import { RefObject, useLayoutEffect } from "react";
import { acquireNativeScrollGuard } from "./nativeScrollGuard";

export function useMenuScroll(open: boolean, listRef: RefObject<HTMLUListElement | null>): void {
    useLayoutEffect(() => {
        if (!open) return;

        // Reopening navigation always starts with Home and Chats. This effect
        // does not rerun when a profile request or parent rerender completes.
        if (listRef.current) listRef.current.scrollTop = 0;

        const position = { left: window.scrollX, top: window.scrollY };
        const native = Boolean((window as any).ReactNativeWebView);
        const releaseGuard = acquireNativeScrollGuard();
        const root = document.getElementById("root");
        const properties = ["position", "top", "left", "right", "width"];
        const previous = properties.map(name => ({
            name, value: root?.style.getPropertyValue(name) ?? "",
            priority: root?.style.getPropertyPriority(name) ?? "",
        }));
        if (root) {
            // Freeze the page behind the fixed drawer at its original position.
            // body overflow:hidden alone leaves the native offset at zero.
            root.style.position = "fixed";
            root.style.top = `${-position.top}px`;
            root.style.left = "0";
            root.style.right = "0";
            root.style.width = "100%";
        }

        return () => {
            previous.forEach(({ name, value, priority }) => {
                if (value) root?.style.setProperty(name, value, priority);
                else root?.style.removeProperty(name);
            });
            releaseGuard();
            if (!native) window.scrollTo({ ...position, behavior: "auto" });
        };
    }, [open, listRef]);
}
